import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Icon, Button, message } from 'antd';
import printLogo from '../imgs/print-logo.png';
import PropTypes from 'prop-types';
import { getSex, getImageWithToken, formatDA } from '../utils';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { apis } from '../api/index.js';

const ReportPrint = props => {
  const [report, setReport] = useState({});

  useEffect(() => {
    getReport();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getReport = () => {
    const token = props.match.params.token;
    if (!token) return;
    apis.tbReportPreview(token).then(res => {
      if (res.code === '0') {
        let data = { ...res.data };
        //影像所见和诊断建议内容格式转换
        let radiography = data.radiographyDescription || '';
        radiography = radiography.replace(/\r\n/g, '<br />');
        radiography = radiography.replace(/\n/g, '<br />');

        let diagnosis = data.diagnosisDescription || '';
        diagnosis = diagnosis.replace(/\r\n/g, '<br />');
        diagnosis = diagnosis.replace(/\n/g, '<br />');
        const signatureUrl = process.env.PUBLIC_URL + '/imgs/signature/';

        data = { ...data, radiography, diagnosis, signatureUrl };
        setReport(data);

        document.title = data.reportTitle;
      } else message.error(res.message);
    });
  };

  const onDownload = () => {
    const element = document.getElementById('report');
    html2canvas(element).then(canvas => {
      // 获取canvas的宽和高
      const contentWidth = canvas.width;
      const contentHeight = canvas.height;
      //一页pdf显示html页面生成的canvas高度;
      const pageHeight = (contentWidth / 592.28) * 841.89;
      //未生成pdf的html页面高度
      let leftHeight = contentHeight;
      //页面偏移
      let position = 0;
      //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      const imgWidth = 595.28;
      const imgHeight = (592.28 / contentWidth) * contentHeight;

      const pageData = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jspdf('', 'pt', 'a4');

      //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      //当内容未超过pdf一页显示的范围，无需分页
      if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'png', 0, 0, imgWidth, imgHeight);
      } else {
        while (leftHeight > 0) {
          pdf.addImage(pageData, 'png', 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          //避免添加空白页
          if (leftHeight > 0) pdf.addPage();
        }
      }

      pdf.save(`${report.patName}.pdf`);
    });
  };

  const getImgs = report => {
    const subVos = report.subVos || [];
    const selectedVos = subVos.filter(item => item.selectFlag);
    const len = selectedVos.length;
    if (len <= 0) return;
    return subVos.map((item, index) => {
      let url = `/v1/picl/aets/piclarc/rs/studies/${item.studyUid}/series/${item.seriesUid}/instances/${item.sopInstanceId}/frames/1/rendered`;
      return (
        <>
          {item.selectFlag && (
            <span id={`preview-img${index}`} key={index}>
              {getImageWithToken(url, `preview-img${index}`, len)}
            </span>
          )}
        </>
      );
    });
  };

  return (
    <>
      <div className="preview-report" id="report">
        <div className="title">
          <p className="title-1">{report.reportTitle}</p>
          <p className="title-2">胸部X线筛查健康评估报告</p>
        </div>
        <div className="institution">
          <p>送检机构：{report.institutionName}</p>
          <p>检查日期：{report.studyDateTime}</p>
        </div>
        <div className="report-user">
          <Row>
            <Col span={12}>姓名：{report.patName}</Col>
            <Col span={6}>性别：{getSex(report.patSex)}</Col>
            <Col span={6}>年龄：{report.patAge}</Col>
          </Row>
          <Row>
            <Col span={12}>患者编号：{report.patId}</Col>
            <Col span={12}>住院号：{report.hospitalizedNumber}</Col>
          </Row>
          <Row>
            <Col span={12}>联系方式：{report.mobileNumber}</Col>
            <Col span={12}>检查类型：{report.modality}</Col>
          </Row>
          <Row>
            <Col span={12}>检查编号：{report.accessionNumber}</Col>
            <Col span={12}>影像编号：{report.imagesNumber}</Col>
          </Row>
          <Row>
            <Col span={12}>检查部位：{report.applicationItem}</Col>
            {report.critical && (
              <Col span={12}>
                <Icon type="check-square" theme="filled" />
                危急值
              </Col>
            )}
          </Row>
        </div>
        <div className="preview-img">{getImgs(report)}</div>
        <Row gutter={60} className="preview-content">
          <Col span={24}>
            <p className="title">影像所见</p>
            <div
              className="content report-cont"
              dangerouslySetInnerHTML={{ __html: report.radiography }}
            ></div>
          </Col>
        </Row>

        <Row className="preview-content">
          <Col span={24}>
            <p className="title">评估建议</p>
            <div
              className="content report-cont"
              dangerouslySetInnerHTML={{ __html: report.diagnosis }}
            ></div>
          </Col>
        </Row>
        <div className="printer-footer">
          <div className="print-doctor-names">
            {report.institutionId === 100109 && (
              <span className="item">检查日期：{report.studyDateTime}</span>
            )}
            <span className="item">
              九峰报告医生：
              {report.reportSignatureImage ? (
                <img
                  className="signature-img"
                  src={report.signatureUrl + report.reportSignatureImage}
                  alt=""
                />
              ) : (
                report.reportSignature
              )}
            </span>
            {report.verifyUserName && (
              <span className="item">
                九峰审核医生：
                {report.verifySignatureImage ? (
                  <img
                    className="signature-img"
                    src={report.signatureUrl + report.verifySignatureImage}
                    alt=""
                  />
                ) : (
                  report.verifySignature
                )}
              </span>
            )}
            {report.verify2Signature && (
              <span className="item">
                九峰审核医生2：
                {report.verify2SignatureImage ? (
                  <img
                    className="signature-img"
                    src={report.signatureUrl + report.verify2SignatureImage}
                    alt=""
                  />
                ) : (
                  report.verify2Signature
                )}
              </span>
            )}
          </div>
          <div className="print-date">
            {[20, 201].includes(report.state) && (
              <div className="printer-warning-tip">
                风险提示：此为夜间急诊报告，请以正式报告为准
              </div>
            )}
            {report.institutionId === 100109 ? (
              <>九峰医疗远程影像诊断中心合作</>
            ) : (
              <>
                <img className="print-logo" alt="" src={printLogo} />
                &nbsp;&nbsp;江西九峰远程医学影像诊断中心
              </>
            )}
            <span className="print-time">打印日期：{formatDA(new Date())}</span>
            <p className="print-tip">
              此检查仅作为疾病诊断参考依据。希望您仔细阅读并认真关注报告中的建议。
              <br />
              如您有进一步的诊疗需求，请您联系北京胸科医院:电话:010-89509040
            </p>
          </div>
        </div>
      </div>
      <Button
        icon="arrow-down"
        className="tb-report-download"
        onClick={onDownload}
      ></Button>
    </>
  );
};
ReportPrint.propTypes = {
  match: PropTypes.object,
};
export default withRouter(ReportPrint);
